import { Fragment, useEffect, useRef, useState } from 'react'
import { Plus, Search, X } from 'react-feather'
import { useDispatch } from 'react-redux'
import { Input } from 'reactstrap'
import { useAppSelector } from '../../../../redux/hooks'
import { openCloseSidebar, setGlobalSearchTerm, setNewModal } from '../../../../redux/reducers/messenger/messengerSlice'
import { useDebounce } from '../../../../utils/useDebounce'
import ChatContactSetting from './quick-actions'
import { useTranslation } from 'react-i18next'
import ChatModal from './quick-actions/Chat'
import { hideOtherFeature } from '../../../../constants'
import { IconButton } from '../../../../shared/button/IconButton'

const ChatTitle = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { newModal } = useAppSelector((state) => state.messenger)
  const [chatContact, setChatContact] = useState(false)
  const [searchToggle, setSearchToggle] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const searchInputRef = useRef<HTMLInputElement>(null)
  //const { sidebarToggle } = useAppSelector((state) => state.messenger)
  const debouncedSearch = useDebounce(searchTerm, 500)
  const { subChatActiveTab, messengerActiveTab } = useAppSelector((state) => state.messenger)
  const { isChatList } = useAppSelector((state) => state.templateCustomizer)
  const toggleChatContact = () => setChatContact(!chatContact)

  useEffect(() => {
    dispatch(setGlobalSearchTerm(debouncedSearch))
  }, [debouncedSearch, dispatch])

  // Focus the input when the search bar opens so the mobile keyboard appears
  useEffect(() => {
    if (searchToggle && searchInputRef.current) {
      searchInputRef.current.focus()
    }
  }, [searchToggle])

  const toggleSearchClose = () => {
    setSearchToggle(!searchToggle)
    setSearchTerm('')
    dispatch(setGlobalSearchTerm(''))
  }

  const handleToggleSidebar = () => {
    dispatch(openCloseSidebar())
  }

  // const handleRightClick = () => {
  //   dispatch(setMobileMenu())
  //   if (sidebarToggle) {
  //     dispatch(openCloseSidebar(false))
  //   }
  // }

  return (
    <Fragment>
      <div className="template-title border-0">
        <div className="d-flex align-items-center justify-content-between">
          <h5>{t('messages')}</h5>
          {messengerActiveTab !== 'call' && (
            <div className="flex-grow-1">
              <div className="sidebar-view">
                {/* <IconButton
                  variant="primary"
                  className={`pull-right ms-1 mobile-back  mobile-toggler ${sidebarToggle ? 'btn-outline-light' : ''}`}
                  onClick={handleRightClick}
                >
                  <ChevronRight />
                </IconButton> */}
                {!isChatList && (
                  <IconButton className="pull-right left-toggle-icon ms-2" onClick={handleToggleSidebar}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <line
                        x1="3"
                        y1="12"
                        x2="21"
                        y2="12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <line
                        x1="3"
                        y1="18"
                        x2="21"
                        y2="18"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </IconButton>
                )}
              </div>
              <a
                className="icon-btn btn-outline-light btn-sm search contact-search mt-0"
                onClick={() => setSearchToggle(!searchToggle)}
              >
                <Search />
              </a>
              <div className={`form-inline search-form message-search ${searchToggle ? 'open' : ''}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="feather feather-search"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <div className="form-group">
                  <Input
                    innerRef={searchInputRef}
                    autoFocus={searchToggle}
                    className="form-control-plaintext"
                    type="search"
                    placeholder={`Search ${subChatActiveTab}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <div className="icon-close close-search" onClick={toggleSearchClose}>
                    <X />
                  </div>
                </div>
              </div>
              {hideOtherFeature.hideGroup ? (
                <>
                  <button
                    className="icon-btn btn-primary btn-fix chat-cont-toggle outside"
                    onClick={() => {
                      dispatch(setNewModal(0))
                    }}
                  >
                    <Plus />
                  </button>
                  {newModal && <ChatModal />}
                </>
              ) : (
                <button
                  className="icon-btn btn-primary btn-fix chat-cont-toggle outside"
                  onClick={() => {
                    toggleChatContact()
                  }}
                >
                  <Plus />
                  <ChatContactSetting setChatContact={toggleChatContact} chatContact={chatContact} />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default ChatTitle
